import { CommonState } from 'common/types'
import { StoreCategoryParams } from 'common/types/params'
import { StateKey } from 'common/utils/flipState'
import { ReduxCachedState, createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { StoreCategory } from 'common/types/entities/mongo/storeCategory'
import { fetchStoreCategories } from 'common/services/storeCategory'

export interface StoreCategoryState extends ReduxCachedState {
  storeCategories?: StoreCategory[]
  selectedCategory?: StoreCategory
  params: {}
}

const initialState: StoreCategoryState = {
  storeCategories: [],
  selectedCategory: null,
  params: {},
  cacheParam: null,
}

const FETCH = 'storeCategory/FETCH'
const SET = 'storeCategory/SET'

export const fetchStoreCategory = (curState: StateKey, params: StoreCategoryParams, action?: any) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchStoreCategory', { curState, params, action })
  if (action === 'POP' && isCacheHit(getState().storeCategory[curState], cacheParam)) {
    return
  }
  const storeCategories = await fetchStoreCategories(params)
  let selectedCategory = null
  if (storeCategories && storeCategories.length) {
    selectedCategory =
      (params.selectedId && storeCategories.find(category => category._id === params.selectedId)) || storeCategories[0]
  }
  dispatch({
    curState,
    params,
    storeCategories,
    selectedCategory,
    cacheParam,
    type: FETCH,
  })
}

export const setStoreCategory = (curState: StateKey, selectedCategory: StoreCategory) => {
  return {
    curState,
    selectedCategory,
    type: SET,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        storeCategories: action.storeCategories,
        selectedCategory: action.selectedCategory,
        params: action.params,
        cacheParam: action.cacheParam,
      }
    case SET:
      return {
        ...state,
        selectedCategory: action.selectedCategory,
        cacheParam: null,
      }
    default:
      return state
  }
}

export default reducer
